'use client'

import Link from 'next/link'
import Image from 'next/image'
import { useRouter } from 'next/navigation'

export default function Blog3({ blog }) {
  const router = useRouter()

  const addViewNum = async (id) => {
    try {
      const response = await fetch(`/api/blogs/add_Article_Views`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ArticleID: id }),
      })

      const json = await response.json()

      if (json?.Error) {
        console.error(`更新瀏覽次數失敗：${json.Error}`)
      }
    } catch (err) {
      console.error('addViewNum error:', err)
    }
  }

  const handleArticleClick = async (e, elm) => {
    e.preventDefault()

    await addViewNum(elm.ArticleID)

    router.push(`/blogs-list/${elm.ArticleSlug}/${elm.ArticleID}`)
  }

  return (
    <section className="blog-page container pt-1">
      <div className="blog-list mt-5">
        {blog && blog.ArticleData.length > 0 ? (
          blog.ArticleData.map((elm, i) => (
            <div key={i} className="blog-list__item">
              <div className="blog-list__item-image">
                <Image
                  loading="lazy"
                  className="h-auto"
                  src={elm.PicturePath}
                  width="680"
                  height="493"
                  alt={elm.ArticleTitle || 'image'}
                />
              </div>

              <div className="blog-list__item-detail">
                <div className="blog-list__item-title">
                  <Link
                    href={`/blogs-list/${elm.ArticleSlug}/${elm.ArticleID}`}
                    onClick={(e) => handleArticleClick(e, elm)}
                  >
                    {elm.ArticleTitle}
                  </Link>
                </div>

                <div className="blog-list__item-content">
                  <p>{elm.Description}</p>
                </div>

                <div className="blog-list__item-meta">
                  <span className="blog-list__item-meta__date">
                    更新日期: {elm.PublishedDateFormatted}
                  </span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="blog-list__item d-flex justify-content-center">
            <div className="blog-list__item-content">
              <span style={{ fontSize: '24px' }}>該分類沒有資料</span>
            </div>
          </div>
        )}
      </div>
    </section>
  )
}
